import RootState from 'typings/RootState'
import { DataList } from './types'
import { Event } from '../../types/event'

export const selectDataList = (state: RootState): DataList =>
  state.adminpjModelHouse.dataList

export const selectEvent = (state: RootState): Event =>
  state.adminpjModelHouse.event
